var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-upload-dragger',{staticClass:"attachment-list",attrs:{"disabled":_vm.isDisabled,"fileList":_vm.antdAttachments,"listType":"text","multiple":"","showUploadList":{ showPreviewIcon: true, showDownloadIcon: true },"remove":(file) => {
            _vm.onRemove(file);
        },"customRequest":(data) => {
            _vm.customRequest(data);
        },"name":"file"},on:{"preview":_vm.onPreview}},[_c('p',{staticClass:"ant-upload-drag-icon"},[_c('a-icon',{attrs:{"type":"inbox"}})],1),_c('p',{staticClass:"ant-upload-text"},[_vm._v(_vm._s(_vm.$t('Kliknite ovdje ili dovucite datoteke koje želite postaviti')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }